import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const customersApiSlice = createApi({
  reducerPath: 'customersApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    getCashbackOperations: builder.query({
      query: ({ apiManager, customerId, params }) => apiManager.getCashbackOperations(customerId, params),
    }),
    // Paginated `/customers`. Callers pass the page and filters they need and read
    // `response.data`; the CSV export (`format: 'csv'`) must NOT go through here,
    // since the Manager switches to a blob response for it.
    getCustomers: builder.query({
      query: ({ apiManager, ...params }) => apiManager.get(params),
    }),
  }),
  serializeQueryArgs,
});

export const { useGetCashbackOperationsQuery, useGetCustomersQuery } = customersApiSlice;
